import React, { useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const PLAN_OPTIONS = ["Bronze", "Silver", "Gold", "Platinum"];

const AddPackagePlanDrawer = ({ isOpen, onClose, onAddPlan }) => {
  const [formData, setFormData] = useState({
    name: "",
    deliveries: 0,
    expiry_days: 90,
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onAddPlan(formData);
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Add Package Plan</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Select plan"
            type="select"
            options={PLAN_OPTIONS.map((plan) => ({ label: plan, value: plan }))}
          />
          <ReusableInput
            label="Deliveries"
            name="deliveries"
            value={formData.deliveries}
            onChange={handleChange}
            placeholder="Deliveries"
            type="number"
          />
          <ReusableInput
            label="Expiry Days"
            name="expiry_days"
            value={formData.expiry_days}
            onChange={handleChange}
            placeholder="Expiry in days"
            type="number"
          />
          <ReusableInput
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            placeholder="Plan description"
            type="textarea"
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} width="100px" height="40px">
            Cancel
          </GradientButton>
          <GradientButton onClick={handleSubmit} width="100px" height="40px">
            Save
          </GradientButton>
        </Stack>
      }
    />
  );
};

export default AddPackagePlanDrawer;
